export default __webpack_public_path__ + "static/media/featured-in-desktop.328ca5b7.svg";